import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/custom-terms/{id}/permissions']['PUT'];
type Input = ThisApi['params'] & ThisApi['body'];

const updateCustomTermsPermissions = async ({
  id,
  userIds,
  signatureAssignments,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(`/custom-terms/${id}/permissions`, { signatureAssignments, userIds });
  return response.data;
};

export default updateCustomTermsPermissions;
